import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Resume, Cancel, PauseCircled, CalendarEmpty } from '@bibliocommons/base-icons';
import BatchActionButton from '../../../shared/BatchActions/BatchActionButton/BatchActionButton';
import BatchAddToShelfButton from '../../../shared/BatchActions/BatchAddToShelfButton';

export default function HoldsBatchActions({ itemsForAction, handleBatchAction, handleBatchCancel, handleBatchAddToShelf }) {
  // setting this as default for now until we figure multiple batch actions
  const itemSelected = itemsForAction.get('cancel', Immutable.List());
  const shelfItemsSelected = itemsForAction.get('addToShelf', Immutable.List());
  return (
    <div className="cp-holds-batch-actions">
      <BatchActionButton
        className="batch-cancel-button"
        selectedItemCount={itemSelected.size}
        handleClick={() => handleBatchCancel(itemSelected)}>
        <Cancel color="currentcolor" />
        <FormattedMessage id="cancel_button" />
      </BatchActionButton>
      &nbsp;
      <BatchActionButton
        className="batch-pause-button"
        selectedItemCount={itemSelected.size}
        handleClick={() => handleBatchAction(itemSelected)}>
        <PauseCircled />
        <FormattedMessage id="holds_batch_action_pause" />
      </BatchActionButton>
      &nbsp;
      <BatchActionButton
        className="batch-resume-button"
        selectedItemCount={itemSelected.size}
        handleClick={() => handleBatchAction(itemSelected)}>
        <Resume />
        <FormattedMessage id="holds_batch_action_resume" />
      </BatchActionButton>
      &nbsp;
      <BatchActionButton
        className="batch-edit-dates-button"
        selectedItemCount={itemSelected.size}
        handleClick={() => handleBatchAction(itemSelected)}>
        <CalendarEmpty />
        <FormattedMessage id="holds_batch_action_edit_dates" />
      </BatchActionButton>
      &nbsp;
      <BatchAddToShelfButton
        selectedItemCount={shelfItemsSelected.size}
        handleClick={(shelfName) => handleBatchAddToShelf(shelfItemsSelected, shelfName)} />
    </div>
  );
}

HoldsBatchActions.propTypes = {
  itemsForAction: ImmutablePropTypes.map,
  handleBatchAction: PropTypes.func,
  handleBatchCancel: PropTypes.func,
  handleBatchAddToShelf: PropTypes.func
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsBatchActions/HoldsBatchActions.jsx